{
  "appName": "22-0989 Request education benefit entitlement restoration online",
  "entryFile": "./app-entry.jsx",
  "entryName": "0989-edu-benefits",
  "rootUrl": "/forms/22-0989/request-entitlement-restoration",
  "productId": "27c9d9f9-0d33-424b-bda8-d551742e89a2"
}
